import React from 'react';
import PropTypes from 'prop-types';
import AsyncSelect from 'react-select/async';
import { components } from 'react-select';
import ModalTrigger from '../common/ModalTrigger';
import { getRequest, putRequest } from '../../requestUtils';

const formatError = (error) => (
  error
    ? (
      <p className="error-text">
        { error }
      </p>
    ) : ''
);

function MenuList({ children, ...props }) {
  return (
    <components.MenuList {...props}>
      {Array.isArray(children)
        ? children.slice(0, 10)
        : children}
    </components.MenuList>
  );
}

MenuList.propTypes = {
  children: PropTypes.arrayOf(PropTypes.node),
};

class CompanyMerge extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
    };

    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleSelect = this.handleSelect.bind(this);
  }

  companyOptions(term) {
    const { mergeCompanyId } = this.props;

    return getRequest(
      '/companies/autocomplete_dropdown',
      {
        term,
        show_all: true,
        limit: 50,
      },
    ).then((response) => (
      response.data
        .filter((company) => company.id !== mergeCompanyId)
        .map((i) => ({
          label: i.domain ? `${i.name} <${i.domain}>` : i.name,
          value: i.id,
          resource_id: i.resource_id,
        }))
    ));
  }

  handleSelect(val) {
    this.setState({ selectedCompany: val });
  }

  handleSubmit() {
    const { mergeCompanyId, csrfToken } = this.props;
    const { selectedCompany } = this.state;

    putRequest('/companies/merge', {
      to_keep_id: selectedCompany.value,
      to_merge_id: mergeCompanyId,
    }, csrfToken).then(() => {
      window.location = `/companies/${selectedCompany.resource_id}`;
    });
  }

  render() {
    const { companyName, error } = this.props;
    const { selectedCompany } = this.state;

    return (
      <ModalTrigger
        triggerText={`Merge ${companyName}...`}
        buttonStyles="secondary"
        submitButtonText="Merge"
        cancelButtonText="Cancel"
        handleSubmit={this.handleSubmit}
        closeAfterSubmit
        idKey="merge-company-modal"
      >
        <h2>{`Merge ${companyName} to:`}</h2>
        <div
          id="company-dropdown"
          className="company-select"
          role="button"
          tabIndex={0}
        >
          <AsyncSelect
            id="company"
            className={`company-select-dropdown ${error ? 'error' : ''}`}
            name="user[company_user_attributes][company_attributes][name]"
            classNamePrefix="company-select"
            loadOptions={(input) => this.companyOptions(input)}
            defaultOptions
            placeholder="Company Name"
            onChange={this.handleSelect}
            value={selectedCompany}
            components={{ MenuList, IndicatorSeparator: () => null }}
          />
          { formatError(error) }
        </div>
      </ModalTrigger>
    );
  }
}

CompanyMerge.propTypes = {
  error: PropTypes.string,
  companyName: PropTypes.string.isRequired,
  mergeCompanyId: PropTypes.string.isRequired,
  csrfToken: PropTypes.string.isRequired,
};

CompanyMerge.defaultProps = {
  error: null,
};

export default CompanyMerge;
